import React, { FC, useEffect } from "react";
import { useLocation } from "react-router-dom";

type Props = {
	children: React.ReactNode;
};

const ScrollToTop: FC<Props> = (props: Props) => {
	const { pathname } = useLocation();

	useEffect(() => {
		document.querySelector(".main-container")?.scrollTo(0, 0);
	}, [pathname]);

	return <>{props.children}</>;
};

export default ScrollToTop;
